import type * as SchemaTypes from '../../../apolloClient.types';

import type { RoleAssignmentFragment } from '../../../contexts/UserSession/Usersession.api';
import type { ResultSartResultFragment, ResultSpatialPlanningResultFragment, ResultVisualReactionResultFragment, ResultMl360ResultFragment, ResultSelfDeterminationResultFragment, ResultTeamResilienceResultFragment, ResultLikertScaleFragment, ResultRatingScaleFragment } from '../../../components/blocks/AssessmentResults/shared/Results.api';
import { gql } from '@apollo/client';
import { RoleAssignmentFragmentDoc } from '../../../contexts/UserSession/Usersession.api';
import { ResultSartResultFragmentDoc, ResultSpatialPlanningResultFragmentDoc, ResultVisualReactionResultFragmentDoc, ResultMl360ResultFragmentDoc, ResultSelfDeterminationResultFragmentDoc, ResultTeamResilienceResultFragmentDoc, ResultLikertScaleFragmentDoc, ResultRatingScaleFragmentDoc } from '../../../components/blocks/AssessmentResults/shared/Results.api';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchResultsQueryVariables = SchemaTypes.Exact<{
  pagination?: SchemaTypes.InputMaybe<SchemaTypes.Pagination>;
  filter?: SchemaTypes.InputMaybe<SchemaTypes.AssessmentResultFilterRule>;
  sort?: SchemaTypes.InputMaybe<SchemaTypes.AssessmentResultSortingRule>;
}>;


export type FetchResultsQuery = (
  { __typename: 'Query' }
  & { assessmentResults: (
    { __typename: 'PaginatedAssessmentResult' }
    & Pick<SchemaTypes.PaginatedAssessmentResult, 'count'>
    & { items: Array<(
      { __typename: 'AssessmentResult' }
      & ResultsListItemDataFragment
    )> }
  ) }
);

export type ResultsListItemDataFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'userId' | 'moduleInstanceId' | 'assessmentRunId' | 'completedAt'>
  & { user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
    & { roleAssignments: Array<(
      { __typename: 'RoleAssignment' }
      & RoleAssignmentFragment
    )> }
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name' | 'startDate' | 'endDate' | 'subGroupIds' | 'groupId'>
    & { program?: SchemaTypes.Maybe<(
      { __typename: 'Program' }
      & Pick<SchemaTypes.Program, 'name'>
    )> }
  )>, result: { __typename: 'CardioRespResult' } | { __typename: 'InbodyCompositionResult' } | { __typename: 'IndividualMotivationResult' } | (
    { __typename: 'ML360Result' }
    & ResultMl360ResultFragment
  ) | { __typename: 'PersonalCopingResult' } | { __typename: 'ProcessingSpeedResult' } | (
    { __typename: 'SartResult' }
    & ResultSartResultFragment
  ) | (
    { __typename: 'SelfDeterminationResult' }
    & ResultSelfDeterminationResultFragment
  ) | (
    { __typename: 'SpatialPlanningResult' }
    & ResultSpatialPlanningResultFragment
  ) | { __typename: 'StrengthResult' } | (
    { __typename: 'TeamResilienceResult' }
    & ResultTeamResilienceResultFragment
  ) | { __typename: 'TrainersNotesResult' } | (
    { __typename: 'VisualReactionResult' }
    & ResultVisualReactionResultFragment
  ) }
);

export type FetchResultsProgramsQueryVariables = SchemaTypes.Exact<{
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
  filter?: SchemaTypes.InputMaybe<SchemaTypes.ProgramFilteringRule>;
}>;


export type FetchResultsProgramsQuery = (
  { __typename: 'Query' }
  & { programs: (
    { __typename: 'PaginatedProgram' }
    & Pick<SchemaTypes.PaginatedProgram, 'count'>
    & { items: Array<(
      { __typename: 'Program' }
      & ResultsProgramItemDataFragment
    )> }
  ) }
);

export type ResultsProgramItemDataFragment = (
  { __typename: 'Program' }
  & Pick<SchemaTypes.Program, 'id' | 'name' | 'description'>
  & { assessmentRuns: Array<(
    { __typename: 'AssessmentRun' }
    & ResultsAssessmentRunDataFragment
  )>, courseInstance: (
    { __typename: 'CourseInstance' }
    & { executionSequence: Array<SchemaTypes.Maybe<(
      { __typename: 'ExecutionSequence' }
      & Pick<SchemaTypes.ExecutionSequence, 'moduleInstanceId' | 'order'>
      & { moduleInstance?: SchemaTypes.Maybe<(
        { __typename: 'ModuleInstance' }
        & ResultsModuleInstanceDataFragment
      )> }
    )>> }
  ) }
);

export type ResultsModuleInstanceDataFragment = (
  { __typename: 'ModuleInstance' }
  & Pick<SchemaTypes.ModuleInstance, 'id' | 'name' | 'description' | 'moduleDefinitionIdentifier'>
);

export type ResultsAssessmentRunDataFragment = (
  { __typename: 'AssessmentRun' }
  & Pick<SchemaTypes.AssessmentRun, 'id' | 'name' | 'status'>
  & { subGroups?: SchemaTypes.Maybe<Array<(
    { __typename: 'Subgroup' }
    & Pick<SchemaTypes.Subgroup, 'id' | 'name'>
  )>>, group: (
    { __typename: 'Group' }
    & Pick<SchemaTypes.Group, 'id' | 'name'>
  ) }
);

export type ExportResultsQueryVariables = SchemaTypes.Exact<{
  assessmentRunIds: Array<SchemaTypes.Scalars['ObjectID']['input']> | SchemaTypes.Scalars['ObjectID']['input'];
  resultType: SchemaTypes.AssessmentResultType;
  subgroupIds?: SchemaTypes.InputMaybe<Array<SchemaTypes.Scalars['ObjectID']['input']> | SchemaTypes.Scalars['ObjectID']['input']>;
  groupIds?: SchemaTypes.InputMaybe<Array<SchemaTypes.Scalars['ObjectID']['input']> | SchemaTypes.Scalars['ObjectID']['input']>;
  searchText?: SchemaTypes.InputMaybe<SchemaTypes.Scalars['String']['input']>;
  isExcludeDescriptionRow?: SchemaTypes.InputMaybe<SchemaTypes.Scalars['Boolean']['input']>;
  moduleId?: SchemaTypes.InputMaybe<SchemaTypes.Scalars['ObjectID']['input']>;
}>;


export type ExportResultsQuery = (
  { __typename: 'Query' }
  & { exportAssessmentResults: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'ExportAssessmentResultSuccessfulResponse' }
    & { result: (
      { __typename: 'ExportAssessmentResultResult' }
      & Pick<SchemaTypes.ExportAssessmentResultResult, 'downloadUrl'>
    ) }
  ) }
);

export const ResultsListItemDataFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultsListItemData on AssessmentResult {
  id
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
      roleAssignments {
        ... on RoleAssignment {
          ...RoleAssignment
        }
      }
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
    startDate
    endDate
    program {
      name
    }
    subGroupIds
    groupId
  }
  result {
    __typename
    ... on SartResult {
      ...ResultSartResult
    }
    ... on SpatialPlanningResult {
      ...ResultSpatialPlanningResult
    }
    ... on VisualReactionResult {
      ...ResultVisualReactionResult
    }
    ... on ML360Result {
      ...ResultML360Result
    }
    ... on SelfDeterminationResult {
      ...ResultSelfDeterminationResult
    }
    ... on TeamResilienceResult {
      ...ResultTeamResilienceResult
    }
  }
  completedAt
}
    `;
export const ResultsAssessmentRunDataFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultsAssessmentRunData on AssessmentRun {
  id
  name
  status
  subGroups {
    id
    name
  }
  group {
    id
    name
  }
}
    `;
export const ResultsModuleInstanceDataFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultsModuleInstanceData on ModuleInstance {
  id
  name
  description
  moduleDefinitionIdentifier
}
    `;
export const ResultsProgramItemDataFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultsProgramItemData on Program {
  id
  name
  description
  assessmentRuns {
    ...ResultsAssessmentRunData
  }
  courseInstance {
    executionSequence {
      moduleInstanceId
      order
      moduleInstance {
        ...ResultsModuleInstanceData
      }
    }
  }
}
    `;
export const FetchResultsDocument = /*#__PURE__*/ gql`
    query FetchResults($pagination: Pagination, $filter: AssessmentResultFilterRule, $sort: AssessmentResultSortingRule) {
  assessmentResults(pagination: $pagination, filter: $filter, sort: $sort) {
    count
    items {
      ...ResultsListItemData
    }
  }
}
    ${ResultsListItemDataFragmentDoc}
${RoleAssignmentFragmentDoc}
${ResultSartResultFragmentDoc}
${ResultSpatialPlanningResultFragmentDoc}
${ResultVisualReactionResultFragmentDoc}
${ResultMl360ResultFragmentDoc}
${ResultSelfDeterminationResultFragmentDoc}
${ResultTeamResilienceResultFragmentDoc}
${ResultLikertScaleFragmentDoc}
${ResultRatingScaleFragmentDoc}`;

/**
 * __useFetchResultsQuery__
 *
 * To run a query within a React component, call `useFetchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchResultsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFetchResultsQuery(baseOptions?: Apollo.QueryHookOptions<FetchResultsQuery, FetchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchResultsQuery, FetchResultsQueryVariables>(FetchResultsDocument, options);
      }
export function useFetchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchResultsQuery, FetchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchResultsQuery, FetchResultsQueryVariables>(FetchResultsDocument, options);
        }
// @ts-ignore
export function useFetchResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchResultsQuery, FetchResultsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchResultsQuery, FetchResultsQueryVariables>;
export function useFetchResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchResultsQuery, FetchResultsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchResultsQuery | undefined, FetchResultsQueryVariables>;
export function useFetchResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchResultsQuery, FetchResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchResultsQuery, FetchResultsQueryVariables>(FetchResultsDocument, options);
        }
export type FetchResultsQueryHookResult = ReturnType<typeof useFetchResultsQuery>;
export type FetchResultsLazyQueryHookResult = ReturnType<typeof useFetchResultsLazyQuery>;
export type FetchResultsSuspenseQueryHookResult = ReturnType<typeof useFetchResultsSuspenseQuery>;
export type FetchResultsQueryResult = Apollo.QueryResult<FetchResultsQuery, FetchResultsQueryVariables>;
export const FetchResultsProgramsDocument = /*#__PURE__*/ gql`
    query FetchResultsPrograms($companyId: ObjectID!, $filter: ProgramFilteringRule) {
  programs(companyId: $companyId, filter: $filter) {
    count
    items {
      ...ResultsProgramItemData
    }
  }
}
    ${ResultsProgramItemDataFragmentDoc}
${ResultsAssessmentRunDataFragmentDoc}
${ResultsModuleInstanceDataFragmentDoc}`;

/**
 * __useFetchResultsProgramsQuery__
 *
 * To run a query within a React component, call `useFetchResultsProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchResultsProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchResultsProgramsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchResultsProgramsQuery(baseOptions: Apollo.QueryHookOptions<FetchResultsProgramsQuery, FetchResultsProgramsQueryVariables> & ({ variables: FetchResultsProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchResultsProgramsQuery, FetchResultsProgramsQueryVariables>(FetchResultsProgramsDocument, options);
      }
export function useFetchResultsProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchResultsProgramsQuery, FetchResultsProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchResultsProgramsQuery, FetchResultsProgramsQueryVariables>(FetchResultsProgramsDocument, options);
        }
// @ts-ignore
export function useFetchResultsProgramsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchResultsProgramsQuery, FetchResultsProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchResultsProgramsQuery, FetchResultsProgramsQueryVariables>;
export function useFetchResultsProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchResultsProgramsQuery, FetchResultsProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchResultsProgramsQuery | undefined, FetchResultsProgramsQueryVariables>;
export function useFetchResultsProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchResultsProgramsQuery, FetchResultsProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchResultsProgramsQuery, FetchResultsProgramsQueryVariables>(FetchResultsProgramsDocument, options);
        }
export type FetchResultsProgramsQueryHookResult = ReturnType<typeof useFetchResultsProgramsQuery>;
export type FetchResultsProgramsLazyQueryHookResult = ReturnType<typeof useFetchResultsProgramsLazyQuery>;
export type FetchResultsProgramsSuspenseQueryHookResult = ReturnType<typeof useFetchResultsProgramsSuspenseQuery>;
export type FetchResultsProgramsQueryResult = Apollo.QueryResult<FetchResultsProgramsQuery, FetchResultsProgramsQueryVariables>;
export const ExportResultsDocument = /*#__PURE__*/ gql`
    query ExportResults($assessmentRunIds: [ObjectID!]!, $resultType: AssessmentResultType!, $subgroupIds: [ObjectID!], $groupIds: [ObjectID!], $searchText: String, $isExcludeDescriptionRow: Boolean, $moduleId: ObjectID) {
  exportAssessmentResults(
    assessmentRunIds: $assessmentRunIds
    resultType: $resultType
    subgroupIds: $subgroupIds
    groupIds: $groupIds
    searchText: $searchText
    isExcludeDescriptionRow: $isExcludeDescriptionRow
    moduleId: $moduleId
  ) {
    ... on ExportAssessmentResultSuccessfulResponse {
      result {
        downloadUrl
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    `;

/**
 * __useExportResultsQuery__
 *
 * To run a query within a React component, call `useExportResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportResultsQuery({
 *   variables: {
 *      assessmentRunIds: // value for 'assessmentRunIds'
 *      resultType: // value for 'resultType'
 *      subgroupIds: // value for 'subgroupIds'
 *      groupIds: // value for 'groupIds'
 *      searchText: // value for 'searchText'
 *      isExcludeDescriptionRow: // value for 'isExcludeDescriptionRow'
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useExportResultsQuery(baseOptions: Apollo.QueryHookOptions<ExportResultsQuery, ExportResultsQueryVariables> & ({ variables: ExportResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportResultsQuery, ExportResultsQueryVariables>(ExportResultsDocument, options);
      }
export function useExportResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportResultsQuery, ExportResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportResultsQuery, ExportResultsQueryVariables>(ExportResultsDocument, options);
        }
// @ts-ignore
export function useExportResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportResultsQuery, ExportResultsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportResultsQuery, ExportResultsQueryVariables>;
export function useExportResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportResultsQuery, ExportResultsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportResultsQuery | undefined, ExportResultsQueryVariables>;
export function useExportResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportResultsQuery, ExportResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportResultsQuery, ExportResultsQueryVariables>(ExportResultsDocument, options);
        }
export type ExportResultsQueryHookResult = ReturnType<typeof useExportResultsQuery>;
export type ExportResultsLazyQueryHookResult = ReturnType<typeof useExportResultsLazyQuery>;
export type ExportResultsSuspenseQueryHookResult = ReturnType<typeof useExportResultsSuspenseQuery>;
export type ExportResultsQueryResult = Apollo.QueryResult<ExportResultsQuery, ExportResultsQueryVariables>;